import { UserflowOnboardingIds } from '../models/userflow-onboarding-ids.interface';

export interface OnboardingService {
  get onboardingIDs(): UserflowOnboardingIds;
  initialize: (ids: UserflowOnboardingIds, url: string) => void;

  getAdvancedOnboardingProgress: () => Promise<number>;
  getFreeOnboardingProgress: () => Promise<number>;
  getPaidOnboardingProgress: () => Promise<number>;
  getOnboardingProgress: (contentId: string) => Promise<number>;
}
